import { toQueryString } from './queryString'

/**
 * Appends query parameters to a given url
 * 
 * @param {String} currentUrl 
 * @param {Object} parameters 
 * @param {bool} asObject 
 * @returns 
 */
export default function urlProcessor(currentUrl, parameters, asObject = false) {
    if(currentUrl === null){
        return ''
    }

    let urlObject = new URL(currentUrl)

    toQueryString(parameters, urlObject.searchParams, true)

    return asObject
        ? urlObject
        : decodeURIComponent(urlObject.toString())
}

/**
 * Gets the redirect url we should use by default if we don't have one for forms
 * 
 * (/account?view=my-profile&type={$TYPE})
 * 
 * @param {String} type 
 * @returns {String}
 */
export const getDefaultRedirect = (type) => {
    const defaultRedirectUrl = new URL(window.phpVals.acc.urls.siteRoot)

    defaultRedirectUrl.pathname = '/account'
    defaultRedirectUrl.searchParams.append('view', 'my-profile')

    defaultRedirectUrl.searchParams.append('type', type)

    return defaultRedirectUrl.toString()
}